import React, { FC, ButtonHTMLAttributes } from 'react'

import classNames from 'classnames'
import {
  ArrowLeftIcon,
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
} from '@heroicons/react/24/solid'

interface BaseProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string
  disabled?: boolean
}

export const PaginationNavButton: FC<
  BaseProps & { direction: 'prev' | 'next' }
> = ({ direction, className, disabled, children, ...rest }) => {
  const label = direction === 'prev' ? 'Página anterior' : 'Página siguiente'
  return (
    <button
      type="button"
      aria-label={label}
      disabled={disabled}
      className={classNames(
        'px-2 py-1 rounded border text-sm font-medium transition-colors',
        'bg-white text-main-500 hover:bg-gray-100',
        disabled && 'opacity-50 pointer-events-none',
        className
      )}
      {...rest}
    >
      {children ||
        (direction === 'prev' ? (
          <ChevronDoubleLeftIcon className="h-4 w-4 mr-1" aria-hidden="true" />
        ) : (
          <ChevronDoubleRightIcon className="h-4 w-4 mr-1" aria-hidden="true" />
        ))}
    </button>
  )
}

export const PaginationPageButton: FC<
  BaseProps & { page: number; active?: boolean }
> = ({ page, active, className, disabled, ...rest }) => {
  return (
    <button
      type="button"
      aria-current={active ? 'page' : undefined}
      disabled={disabled}
      className={classNames(
        'px-2 py-1 rounded border text-sm font-medium transition-colors',
        active
          ? 'bg-main-500 text-white'
          : 'bg-white text-black hover:bg-gray-100',
        disabled && 'opacity-50 pointer-events-none',
        className
      )}
      {...rest}
    >
      {page}
    </button>
  )
}

export default PaginationPageButton
